__turbopack_context__.v({
  "giftForward": "cvKkYG_giftForward",
  "giftForwardBody": "cvKkYG_giftForwardBody",
  "giftForwardHeader": "cvKkYG_giftForwardHeader",
  "giftForwardHeading": "cvKkYG_giftForwardHeading",
  "outlinePill": "cvKkYG_outlinePill",
  "panel": "cvKkYG_panel",
  "panels": "cvKkYG_panels",
  "planBody": "cvKkYG_planBody",
  "planGrid": "cvKkYG_planGrid",
  "planHeader": "cvKkYG_planHeader",
  "planHeaderActions": "cvKkYG_planHeaderActions",
  "planHeading": "cvKkYG_planHeading",
  "planPanels": "cvKkYG_planPanels",
  "primaryPill": "cvKkYG_primaryPill",
});
